import { createFileRoute } from '@tanstack/react-router';
import AssignmentDetailView from '../terminal/TerminalAssignmentsView/components/AssignmentDetailView';
export const Route = createFileRoute('/terminals/assignments/$id')({
  component: AssignmentDetailView,
});
